import React from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';

import { Blank, Loader } from '@src/library/components/common';

import { useInfiniteList } from './model';
import * as st from './styles.module.scss';

interface Props {
	params?: {
		search?: string;
		tags?: number[];
		module?: number;
		[x: string]: any;
	};
	children: (id: number) => JSX.Element;
}

export const InfiniteList: React.FC<Props> = ({ params, children }) => {
	const { loading, hasNextPage, loadMore, error, items } = useInfiniteList(params);

	const [sentryRef, { rootRef }] = useInfiniteScroll({
		loading,
		hasNextPage,
		onLoadMore: loadMore,
		disabled: !!error,
		rootMargin: '0px 0px 400px 0px',
	});

	return (
		<div className={st.list} ref={rootRef}>
			{items.map((id) => (
				<React.Fragment key={id}>{children(id)}</React.Fragment>
			))}

			{(loading || hasNextPage) && <div ref={sentryRef} />}

			{items.length === 0 && !loading && (
				<Blank text="У Вас нет ни одной запланированной консультации" />
			)}

			{items.length === 0 && loading && <Loader />}
		</div>
	);
};
